import { render, staticRenderFns } from "./StartSection.vue?vue&type=template&id=375144bf&scoped=true&"
import script from "./StartSection.vue?vue&type=script&lang=js&"
export * from "./StartSection.vue?vue&type=script&lang=js&"
import style0 from "./StartSection.vue?vue&type=style&index=0&id=375144bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375144bf",
  null
  
)

export default component.exports